<template>
  <div class="materials">
    <div class="header">
      <div @click="onCancel">取消</div>
      <div>选择会务要求</div>
      <div class="select">
        <div class="confirm" @click="onConfirm">确认</div>
      </div>
    </div>
    <van-cell-group>
      <van-field
        v-for="(item) in numberList"
        :key="item.key"
        v-model.trim="dataForm[item.key]"
        type="number"
        placeholder="请输入数量"
        :label="item.meetingRequire"
        @input="(e) => changeNumber(e, item.key)"
      />
      <van-field
        v-for="(item) in stringList"
        :key="item.key"
        v-model.trim="dataForm[item.key]"
        type="text"
        placeholder="请输入内容"
        :label="item.meetingRequire"
        @input="(e) => changeNumber(e, item.key)"
      />
    </van-cell-group>
    <van-checkbox-group v-model="checkedList">
      <van-cell-group>
        <van-cell
          v-for="(item, index) in checkBoxList"
          :key="index"
          clickable
          :title="item.meetingRequire"
        >
          <template #right-icon>
            <van-checkbox ref="checkboxes" :name="item.key" />
          </template>
        </van-cell>
      </van-cell-group>
    </van-checkbox-group>
  </div>
</template>

<script>
import { meetingRequires } from '@/api/user';
import { Checkbox, CheckboxGroup } from 'vant';

export default {
  name: 'AddMaterials',
  components: {
    [CheckboxGroup.name]: CheckboxGroup,
    [Checkbox.name]: Checkbox
  },
  data() {
    return {
      checkedList: [],
      checkBoxList: [],
      numberList: [],
      stringList: [],
      dataForm: {}
    };
  },
  computed: {
    checkedData() {
      this.checkedList = this.$store.state.requiresInfo.checkedList;
      this.dataForm = this.$store.state.requiresInfo.dataForm;
      return this.$store.state.requiresInfo;
    }
  },
  watch: {
    checkedList(val) {
      this.$store.dispatch('setRequiresInfo', { info: { dataForm: this.dataForm, checkedList: val }});
    },
    dataForm(val) {
      this.$store.dispatch('setRequiresInfo', { info: { dataForm: val, checkedList: this.checkedList }});
    },
    checkedData() {}
  },
  created() {
    this.dataForm = {}
    this.getInfo();
    this.checkedList = this.$store.state.submitForm.requiresInfo.checkedList;
    this.dataForm = JSON.parse(JSON.stringify(this.$store.state.submitForm.requiresInfo.dataForm));;
  },
  methods: {
    getInfo() {
      meetingRequires({}).then((res) => {
        const checkBoxList = [];
        const numberList = [];
        const stringList = [];
        res.data.forEach((item, index) => {
          item.key = this.unicode(item.meetingRequire);
          // this.dataForm[item.key] = '';
          if (item.requireType === 'boolean') {
            checkBoxList.push(item);
          }
          if (item.requireType === 'number') {
            numberList.push(item);
          }
          if (item.requireType === 'string') {
            stringList.push(item);
          }
        });
        this.checkBoxList = checkBoxList;
        this.numberList = numberList;
        this.stringList = stringList;
      });
    },
    changeNumber(e, key) {
    },
    unicode(str) {
      let value = '';
      for (let i = 0; i < str.length; i += 1) {
        value += `\\u${this.left_zero_4(parseInt(str.charCodeAt(i)).toString(16))}`;
      }
      return value;
    },
    left_zero_4(str) {
      if (str != null && str !== '' && str !== 'undefined') {
        if (str.length === 2) {
          return `00${str}`;
        }
      }
      return str;
    },
    onCancel() {
      this.dataForm = {};
      this.$store.dispatch('setRequiresInfo', { info: { dataForm: {}, checkedList: [] }});
      this.$router.push({
        name: 'roomInfo'
      });
    },
    onConfirm() {
      const keyList = Object.keys(this.dataForm);
      const list = [];
      keyList.forEach((key) => {
        if (this.dataForm[key]) {
          const a = key.replace(/\\/g, '%');
          const data = {
            meetingRequire: unescape(a),
            requireType: typeof this.dataForm[key],
            requireValue: this.dataForm[key]
          };
          list.push(data);
        }
      });
      this.checkedList.forEach(item => {
        const a = item.replace(/\\/g, '%');
        const data = {
          meetingRequire: unescape(a),
          requireType: 'boolean',
          requireValue: true
        };
        list.push(data);
      });
      this.$router.push({
        name: 'roomInfo'
      });
      this.$store.dispatch('setRequires', { list, info: { dataForm: this.dataForm, checkedList: this.checkedList }});
    }
  }
};
</script>

<style lang="less">
.materials {
  position: relative;
  .header {
    height: 0.44rem;
    font-size: 0.17rem;
    font-weight: 400;
    line-height: 0.24rem;
    color: #333333;
    background: #FFFFFF;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 0.135rem;
    .confirm {
      color: #3B86FF;
    }
  }
}
</style>
